<script>
    import Layout from "../../layouts/main"
    import PageHeader from "../../components/page-header"
    import List from "./List.vue"
    import AddButton from "../../components/buttons/AddButton.vue"
    import NormalButton from "../../components/buttons/NormalButton.vue"
    import Shortcuts from './Shortcuts.vue'
    import FormInput from "../../components/forms/FormInput.vue"
    import FormSwitchCheckbox from "../../components/forms/FormSwitchCheckbox.vue"
    import FormPasswordInput from "../../components/forms/FormPasswordInput.vue"
    import FormPhoneInput from "../../components/forms/FormPhoneInput.vue"
    import Multiselect from "vue-multiselect"
    import FormInputWithEyeIcon from "../../components/forms/FormInputWithEyeIcon.vue"
    import FormModal from "../../components/modals/FormModal.vue"

    export default {
        components: { Layout, PageHeader, List, AddButton, Shortcuts, FormModal, NormalButton, FormInput, FormSwitchCheckbox, FormPasswordInput, FormPhoneInput, Multiselect, FormInputWithEyeIcon },
        props: {
            ultraAdmins: Array,
            officeExecutives: Number,
            totalUltraAdmins: Number,
            othersOfficeExecutives: Number,
            allEnterprisePartners: Array
        },
        data() {
            return {
                title: "Ultra Admin Management",
                items: [
                    {
                        text: "Apps",
                        href: "/",
                    },
                    {
                        text: "Ultra Admin",
                        active: true,
                    },
                ],
                showCreateModal: false,
                isButtonLoading: false,
                submitButtonText: 'Create',
                createData: {
                    fullName: null,
                    email: null,
                    phone: null,
                    autoGenerate: true,
                    password: null,
                    confirmPassword: null,
                    selectedEps: []
                }
            }
        },
        computed: {
            // Example Admin, Enterprise Partner, Tax Company, Tax Payer
            browserTitle() {
                return this.$page.props.auth.user.user_type_text + ' - Ultra Admin Management'
            },
            // Example admin, sb, tc, tp
            userTypeAbbr() {
                return this.$page.props.auth.user.user_type_abbr
            },
        },
        methods: {
            handleCreateSubmit() {
                this.isButtonLoading = true
                this.submitButtonText = `<i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>Loading`
                this.$inertia.post(route('ultra-admin.store'), this.createData, {
                    onSuccess: (response) => {
                        this.showCreateModal = false
                        this.$toastr.s("Created Successfully")
                        this.submitButtonText = 'Create'
                        this.isButtonLoading = false
                        this.createData = {
                            fullName: null,
                            email: null,
                            phone: null,
                            autoGenerate: true,
                            password: null,
                            confirmPassword: null,
                            selectedEps: []
                        }
                    },
                    onError: (errors) => {
                        this.isButtonLoading = false
                        this.submitButtonText = 'Create'
                        if (errors.message) {
                            this.$toastr.e(errors.message)
                        }
                    },
                })
            },
            clickCreateButton() {
                this.showCreateModal = true
            },
            hideModal() {
                this.showCreateModal = false
                this.createData = {
                    fullName: null,
                    email: null,
                    phone: null,
                    autoGenerate: true,
                    password: null,
                    confirmPassword: null,
                    selectedEps: []
                }
            },
            EpsDropdownCustomLabel(option) {
                return `${option.name}, ${option.email}`
            },
        }
    }
</script>
    
<template>
    <Layout>
        <Head :title="browserTitle" />
        <PageHeader :title="title" :items="items" />
        <div class="checkout-tabs d-xl-flex">
            <div class="w-100">
                <div class="d-md-flex">
                    <div class="w-100">
                        <div class="row justify-content-between">
                            <div class="col-xl-2 col-sm-3">
                                <Shortcuts 
                                    :officeExecutives="officeExecutives"
                                    :totalUltraAdmins="totalUltraAdmins"
                                    :othersOfficeExecutives="othersOfficeExecutives"
                                />
                            </div>
                            <div class="col-xl-10 col-sm-9">
                                <div class="col-auto text-sm-end">
                                    <AddButton :onClick="clickCreateButton" classes="mb-2">Add New Ultra Admin</AddButton>
                                </div>
                                <List 
                                    :ultraAdmins="ultraAdmins" 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <FormModal
            :isShow="showCreateModal"
            title="Create New Ultra Admin"
            :isButtonLoading="isButtonLoading"
            :isShowSubmitButton="true"
            :isShowCancelButton="true"
            :clickSubmitButton="handleCreateSubmit"
            :submitButtonText="submitButtonText"
            @hideModal="hideModal"
        >
            <div class="row">
                <div class="col-12">
                    <div class="mb-3">
                        <FormInput title="Full Name" v-model='createData.fullName' :required="true" :error="$page.props.errors.fullName" type="text" name="fullName" />
                    </div>
                </div>
                <div class="col-12">
                    <div class="mb-3">
                        <FormInput title="Email" v-model='createData.email' :required="true" :error="$page.props.errors.email" type="text" name="email" />
                    </div>
                </div>
                <div class="col-12">
                    <div class="mb-3">
                        <FormPhoneInput title="Phone" :model='createData.phone' :required="false" :error="$page.props.errors.phone" type="text" name="phone" @phoneFormatted="createData.phone = $event" />
                    </div>
                </div>
                <div class="col-sm-12 align-self-center">
                    <FormSwitchCheckbox id="generate_password" v-model="createData.autoGenerate" name="autoGenerate" label="Auto Generate Password" classes="mb-3" />
                </div>

                <template v-if="!createData.autoGenerate">
                    <div class="col-12">
                        <div class="mb-3">
                            <FormInputWithEyeIcon 
                                title="Password"
                                placeholder="Password"
                                v-model='createData.password'
                                :required="true" 
                                :error="$page.props.errors.password"
                            />
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="mb-3">
                            <FormInput title="Confirm Password" v-model='createData.confirmPassword' :required="true" :error="$page.props.errors.confirmPassword" type="password" name="confirmPassword" />
                        </div>
                    </div>
                </template>

                <div class="col-sm-12">
                    <div class="mb-3">
                        <label class="form-label">
                            Select Enterprise Partners
                        </label>
                        <Multiselect
                            v-model="createData.selectedEps"
                            placeholder="Choose Enterprise Partner"
                            track-by="id"
                            :custom-label="EpsDropdownCustomLabel"
                            :options="allEnterprisePartners"
                            :multiple="true"
                            :taggable="true"
                            :hide-selected="true"
                            :class="{
                                'is-invalid': $page.props.errors.selectedEps,
                            }"
                        ></Multiselect>
                        <div
                            v-if="$page.props.errors.selectedEps"
                            class="invalid-feedback"
                        >
                            {{ $page.props.errors.selectedEps }}
                        </div>
                    </div>
                </div>
            </div>
        </FormModal>
    </Layout>
</template>
    